import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Dropdown, Form, Row, Tab, Tabs } from "react-bootstrap";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import { GetSettings, PostSettings, UploadFile } from "api/endpoints";

import { FloatingLabel, } from "react-bootstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import { FiUpload } from "react-icons/fi";
import MEILoader from "components/ckeditor/MEILoader";
import FilePreviewer from "components/ckeditor/MEIFilePreview";





const schema = yup
    .object({
        HEADER_LOGO: yup.string(),
        FOOTER_LOGO: yup.string(),
        CONTACT_PHONE_1: yup.string().required("This field can't be empty"),
        CONTACT_PHONE_2: yup.string(),
        CONTACT_EMAIL: yup.string(),
        CONTACT_LOCATION: yup.string(),
        CONTACT_GOOGLE_MAP: yup.string(),
        CONTACT_US_RECEIVE_EMAIL: yup.string(),
        CONTACT_MEDIA_FACEBOOK: yup.string(),
        CONTACT_MEDIA_TWITTER: yup.string(),
        CONTACT_MEDIA_LINKEDIN: yup.string(),
        CONTACT_MEDIA_YOUTUBE: yup.string(),
        CONTACT_MEDIA_GOOGLE_PLUS: yup.string(),
        CONTACT_MEDIA_INSTAGRAM: yup.string(),
        FOOTER_DESCRIPTION: yup.string(),
        COPYRIGHTS_TEXT: yup.string(),
        CONTACT_US_HEADER_MEDIA: yup.string(),

    })
    .required();

const initialForm = {
    HEADER_LOGO: '',
    FOOTER_LOGO: '',
    CONTACT_PHONE_1: '',
    CONTACT_PHONE_2: '',
    CONTACT_EMAIL: '',
    CONTACT_LOCATION: '',
    CONTACT_GOOGLE_MAP: '',
    CONTACT_US_RECEIVE_EMAIL: '',
    CONTACT_MEDIA_FACEBOOK: '',
    CONTACT_MEDIA_TWITTER: '',
    CONTACT_MEDIA_LINKEDIN: '',
    CONTACT_MEDIA_YOUTUBE: '',
    CONTACT_MEDIA_GOOGLE_PLUS: '',
    CONTACT_MEDIA_INSTAGRAM: '',
    FOOTER_DESCRIPTION: '',
    COPYRIGHTS_TEXT: '',
    CONTACT_US_HEADER_MEDIA: '',

};

const multlines = [
    'FOOTER_DESCRIPTION',
    'CONTACT_GOOGLE_MAP',
];
const filetypes = [
    'HEADER_LOGO',
    'FOOTER_LOGO',
    'CONTACT_US_HEADER_MEDIA '
];

const SettingsForm = ({ settings, saveButtonRef, setLoading }) => {


    const {
        register,
        formState: { errors },
        setValue,
        watch
    } = useFormContext();


    const handleFileChange = (e, key) => {
        const file = e.target.files[0];
        if (file) {


            const allowedTypes = key === 'CONTACT_US_HEADER_MEDIA ' ? ['image/jpeg', 'image/jpg', 'image/png', 'video/mp4'] : ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                toast.error('Invalid File Format', {
                    theme: "colored",
                });
                e.target.value = '';
                return
            }
            else {
                setLoading(true)
                const formData = new FormData();
                formData.append('file', file);

                UploadFile(formData).then(res => {
                    toast.success('File Uploaded Successfully!', {
                        theme: "colored",
                    });
                    setValue(key, res?.data)
                    saveButtonRef.current.click()
                    e.target.value = '';
                    setLoading(false)
                }).catch(err => {
                    setLoading(false)
                    toast.error('File Uploading Failed', {
                        theme: "colored",
                    });
                });
            }

        }



    };


    return (
        <>

            <Row className="gx-2 gy-3 pt-2">
                {settings.map((sett, index) => (

                    multlines.includes(sett.key) ?
                        <Col key={index} md="12">
                            <Form.Group>
                                <FloatingLabel
                                    controlId="floatingInput"
                                    label={`${sett.key?.replaceAll('_', ' ')}`}
                                    className=""
                                >
                                    <Form.Control
                                        as="textarea"
                                        placeholder=""

                                        style={{ height: '120px' }}
                                        isInvalid={!!errors[sett.key]}
                                        {...register(sett.key)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors[sett.key]?.message}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        : filetypes.includes(sett.key) ?
                            <Col md={12} style={{ position: 'relative' }}>
                                {/* <Form.Group>
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label={`${sett.key?.replaceAll('_', ' ')}`}
                                        className=""
                                    >
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            isInvalid={!!errors[sett.key]}
                                            {...register(sett.key)}
                                            onKeyDown={e => e.preventDefault()}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors[sett.key]?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group> */}


                                <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
                                    {`${sett.key?.replaceAll('_', ' ')}`}{sett.key === 'CONTACT_US_HEADER_MEDIA ' && '(1920 X 300)'}
                                </Form.Label>
                                <FilePreviewer accept=" .jpg, .jpeg, .png" furl={watch(sett.key)} />


                                <Form.Label htmlFor={`file-upload${index}`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
                                    <FiUpload className="me-1" size={40} />
                                </Form.Label>
                                <Form.Control
                                    id={`file-upload${index}`}
                                    type="file"
                                    style={{ width: '120px' }}
                                    onChange={(e) => handleFileChange(e, sett.key)}
                                    className="d-none"
                                    accept={sett.key === 'CONTACT_US_HEADER_MEDIA ' ? ".jpg,.jpeg,.png,.mp4" : ".jpg,.jpeg,.png"}
                                />
                            </Col>
                            :
                            <Col key={index} md="12">
                                <Form.Group>
                                    <FloatingLabel
                                        controlId="floatingInput"
                                        label={`${sett.key?.replaceAll('_', ' ')}`}
                                        className=""
                                    >
                                        <Form.Control
                                            type="text"
                                            placeholder=""
                                            isInvalid={!!errors[sett.key]}
                                            {...register(sett.key)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors[sett.key]?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                ))

                }

            </Row>
        </>
    );
};











const Settings = () => {

    const saveButtonRef = useRef(null);


    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {},
    });
    const { handleSubmit, reset } = methods;


    const onSubmit = (data) => {
        console.log(data);
        setLoading(true)
        const finalData = settings.map((sett) => ({
            key: sett.key,
            value: data[sett.key]
        }))


        PostSettings(finalData).then(res => {

            toast.success('Settings Saved Successfully', {
                theme: "colored",
            });
            setLoading(false)

        }).catch(err => {

            toast.error('Settings Saving Failed', {
                theme: "colored",
            });
            setLoading(false)
            console.log(err, 'PostDownloadsError')

        });


    };

    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(false);


    const [editData, setEditData] = useState({});



    const fetchSettings = () => {
        setLoading(true)
        GetSettings().then(res => {

            const settingsData = {};
            res?.data?.data?.filter(set => set.key !== 'ACTIVE_JOBS_AVAILABLE').map((sett) => {
                settingsData[sett.key] = sett.value
            })
            console.log(settingsData, 'settingsData')
            reset(settingsData)
            setSettings(res?.data?.data?.filter(set => set.key !== 'ACTIVE_JOBS_AVAILABLE').sort((a, b) => a.order - b.order));
            setLoading(false)

        }).catch(err => {
            setLoading(false)
            console.log(err, 'GetSettingsAPIError')
        })

    };

    useEffect(() => {
        fetchSettings();

    }, []);






    return (
        <>
            <div className="py-2 pt-0">
                <BreadCrumb />
            </div>

            <MEILoader showLoader={loading} />

            <Card className="mb-0">
                <Card.Header>
                    <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Profile Settings</h5>
                </Card.Header>
                <Card.Body className="pt-0 p-3" >

                    <FormProvider {...methods}>
                        <Form onSubmit={handleSubmit(onSubmit)}>


                            <Row className="g-3">


                                {/* style={{ maxHeight: '60vh', minHeight: '60vh', overflow: 'auto' }} */}
                                <Col lg={12} className="pb-3">
                                    <SettingsForm settings={settings} saveButtonRef={saveButtonRef} setLoading={setLoading} />
                                </Col>

                                <Col xs={12}>
                                    <Row className="flex-between-center mt-3">
                                        <Col md>
                                         {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                                        </Col>
                                        <Col xs="auto">
                                            <Button ref={saveButtonRef} variant="primary" type="submit" disabled={loading}>
                                                Save Settings {loading && '...'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>



                        </Form>
                    </FormProvider>

                </Card.Body>
            </Card>


        </>
    );
};

export default Settings;
